/**
 * ⭐ **The three-dot loader of the welcome's wait** [decision 0516; 03-us-kad-6j-i AC-13].
 *
 * ⚠️ **No Figma frame draws it** — a design departure the Operator approved (0516), recorded in
 * `design-qa/known-departures.md` until the design team draws it on *01 · Welcome*. Assembled from the design
 * system's own tokens, as the convention skill § 8 asks where no frame exists: the dots are `--primary`, the
 * colour the app's `Spinner` draws its moving part in.
 *
 * * **Three dots, ⛔ not the ring `Spinner`.** The Operator named the shape: *"un loader de 3 puntitos"*.
 * * **A sober animation:** each dot fades gently (`animate-pulse`, 2 s), 333 ms (a sixth of the 2 s pulse)
 *   after the one before it. ⛔ No spin, no bounce.
 * * **Still under `prefers-reduced-motion: reduce`:** every animated dot carries `motion-reduce:animate-none`,
 *   the `Spinner`'s own convention, so the three dots are drawn and do not move.
 * * **No copy and presentational**, as the `Spinner` is: ⛔ no text and no translation key. The dimmed,
 *   disabled door beside it already carries the state.
 */
export function WaitingDots() {
  return (
    <div className="flex items-center gap-1.5" role="presentation">
      {DOT_DELAYS.map((delay) => (
        <span
          className={`size-2 animate-pulse rounded-full bg-[var(--primary)] motion-reduce:animate-none ${delay}`}
          key={delay}
        />
      ))}
    </div>
  );
}

/** One per dot, and each one's own key: the dots never reorder. Written out so Tailwind's scanner sees them. */
const DOT_DELAYS = [
  '[animation-delay:0ms]',
  '[animation-delay:333ms]',
  '[animation-delay:666ms]',
] as const;
